export default function TextInput({
    value,
    isDisable=false
}) {
  return (
    <input 
        type="text" 
        name=""
        id=""
        className="manual-entry-disabled-input"
        style={{width: '80%', padding: '5px'}}
        value={value}
        disabled={isDisable}
        required={true}
    />
  )
}
